/**
 * OneBrandChartV2 — "One group. Twenty-nine subsidiaries." (simplified, single view)
 * 18 teaching centres vs the Company's 29 subsidiaries, per BExcellent Group
 * Holdings' listing prospectus. Wording tracks the prospectus formulation
 * ("the Company and its subsidiaries") so the count can't be misread as a
 * group total. Sources: BExcellent Group Holdings (HKEX: 1775) prospectus,
 * 30 Jun 2018 (listed 13 Jul 2018);
 * Education Ordinance (Cap. 279); Companies Ordinance (Cap. 622) s.379.
 */
'use client';

import React, { useEffect } from 'react';

const PSGLOBAL_LOGO =
  'https://images.prismic.io/onepac/ag7UFaYofJOwHelQ_psglobal_color.png?auto=format,compress';

const STYLE_ID = 'obc2-styles';
const CSS = `
.obc2-root { --f: 'Poppins', system-ui, sans-serif; --mono: var(--f);
  --ink: #1B2A33; --ink-2: #3E5460; --body: #5B6B75; --muted: #8A99A3;
  --line: #E4E7EA; --wash: #F5F8F8; --teal: #0f9993; --teal-deep: #0d555c; --gold: #B08A2E; --gold-deep: #7A5F1D;
  box-sizing: border-box; width: 100%; background: #fff; border: 1px solid var(--line);
  border-radius: 20px; box-shadow: 0 10px 20px -10px rgba(4,68,92,0.35); padding: 40px 44px 28px;
  color: var(--ink); font-family: var(--f); -webkit-font-smoothing: antialiased; }
.obc2-root *, .obc2-root *::before, .obc2-root *::after { box-sizing: border-box; margin: 0; padding: 0; }
.obc2-root h1, .obc2-root h2, .obc2-root h3, .obc2-root p, .obc2-root img { margin: 0; }
.obc2-root p { letter-spacing: normal; }
.obc2-root .head { display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; }
.obc2-root .obc2-logo { height: 40px; width: auto; flex: none; }
.obc2-root.compact .obc2-logo { display: none; }
.obc2-root h1 { font-size: 28px; font-weight: 600; letter-spacing: -0.01em; line-height: 1.3; max-width: 560px; }
.obc2-root h1 .gold { color: var(--gold); }
.obc2-root .sub { font-size: 14px; color: var(--body); margin-top: 10px; max-width: 560px; line-height: 1.55; }
.obc2-root .stage { margin-top: 30px; opacity: 0; }
.obc2-root.on .stage { animation: obc2-in .45s ease both; }
@keyframes obc2-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
/* view 1 */
.obc2-root .v1 { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
.obc2-root .big { font-family: var(--mono); font-size: 44px; font-weight: 600; line-height: 1; color: var(--teal-deep); }
.obc2-root .big.gd { color: var(--gold); }
.obc2-root .side-lbl { font-size: 13.5px; font-weight: 500; color: var(--ink-2); margin-top: 6px; }
.obc2-root .cells { margin-top: 18px; display: grid; grid-template-columns: repeat(auto-fill, 34px); gap: 8px; }
.obc2-root .cell { width: 34px; height: 34px; display: flex; align-items: center; justify-content: center; opacity: 0; transform: scale(.4) translateY(8px); transition: opacity .45s ease, transform .55s cubic-bezier(0.34,1.56,0.64,1); }
.obc2-root .cell svg { width: 100%; height: 100%; display: block; }
.obc2-root.on .cell { opacity: 1; transform: none; }
.obc2-root .cell.ctr { color: var(--teal); }
.obc2-root .cell.op { color: var(--teal); }
.obc2-root .cell.mg { color: var(--gold); }
.obc2-root .cell.hs { color: #a3e8e0; }
.obc2-root .note { margin-top: 16px; font-size: 12.5px; color: var(--body); line-height: 1.55; max-width: 520px; opacity: 0; transform: translateY(6px); transition: opacity .5s ease 1.1s, transform .5s ease 1.1s; }
.obc2-root.on .note { opacity: 1; transform: none; }
.obc2-root .note.gd { color: var(--gold-deep); font-weight: 600; }
.obc2-root .key { margin-top: 16px; display: flex; flex-direction: column; gap: 6px; opacity: 0; transform: translateY(6px); transition: opacity .5s ease 1.35s, transform .5s ease 1.35s; }
.obc2-root.on .key { opacity: 1; transform: none; }
.obc2-root .ki { display: flex; gap: 8px; align-items: center; font-size: 12px; color: var(--ink-2); }
.obc2-root .ki i { width: 14px; height: 14px; flex: none; display: flex; }
.obc2-root .ki i svg { width: 100%; height: 100%; }
.obc2-root .foot { margin-top: 28px; padding-top: 16px; border-top: 1px solid var(--line); }
.obc2-root .cap-l { font-size: 13px; line-height: 1.55; color: var(--body); font-style: italic; max-width: 620px; }
.obc2-root .cap-l.gd { color: var(--gold-deep); font-weight: 600; font-style: normal; }
.obc2-root .src { margin-top: 12px; font-family: var(--mono); font-size: 10px; color: var(--muted); line-height: 1.6; }
.obc2-root.compact { padding: 26px 0 20px; border-radius: 0; border-left: none; border-right: none; box-shadow: none; }
.obc2-root.compact h1 { font-size: 22px; }
.obc2-root.compact .v1 { grid-template-columns: 1fr; gap: 28px; }
.obc2-root.compact .cells { grid-template-columns: repeat(auto-fill, 30px); }
.obc2-root.compact .cell { width: 30px; height: 30px; }`;

function useInjectedStyles(): void {
  useEffect(() => {
    const existing = document.getElementById(STYLE_ID);
    if (existing) {
      if (existing.textContent !== CSS) existing.textContent = CSS; // refresh stale CSS after hot-reload
    } else {
      const s = document.createElement('style');
      s.id = STYLE_ID; s.textContent = CSS;
      document.head.appendChild(s);
    }
  }, []);
}

function useInView(ref: React.RefObject<HTMLDivElement | null>): boolean {
  const [inView, setInView] = React.useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    if (typeof IntersectionObserver === 'undefined') {
      const t = window.setTimeout(() => setInView(true), 0);
      return () => window.clearTimeout(t);
    }
    const io = new IntersectionObserver(
      (entries) => { if (entries.some((e) => e.isIntersecting)) setInView(true); },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [ref, inView]);
  return inView;
}

/* Count-up numeral — idle at 0 until `start` flips (scroll-into-view) */
const CountUp: React.FC<{ to: number; start: boolean; delay: number; dur?: number }> = ({ to, start, delay, dur = 900 }) => {
  const [v, setV] = React.useState(0);
  useEffect(() => {
    if (!start) return;
    let raf = 0; let begin = 0;
    const t = window.setTimeout(() => {
      const step = (ts: number): void => {
        if (!begin) begin = ts;
        const p = Math.min((ts - begin) / dur, 1);
        setV(Math.round(to * (1 - Math.pow(1 - p, 3))));
        if (p < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }, delay);
    return () => { window.clearTimeout(t); cancelAnimationFrame(raf); };
  }, [start, to, delay, dur]);
  return <>{v}</>;
};

/* Simple glyphs: schoolhouse (left) and office building (right) */
const SchoolIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round">
    <path d="M4 11 L12 5 L20 11 V20 H4 Z" />
    <path d="M12 5 V2.5 H15.5" />
    <path d="M10 20 V15 H14 V20" />
  </svg>
);
const BuildingIcon: React.FC<{ filled?: boolean }> = ({ filled = true }) => (
  filled ? (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M6 3 H18 V21 H14 V17 H10 V21 H6 Z M9 6 H11 V8 H9 Z M13 6 H15 V8 H13 Z M9 10 H11 V12 H9 Z M13 10 H15 V12 H13 Z M9 14 H11 V16 H9 Z M13 14 H15 V16 H13 Z" fillRule="evenodd" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round">
      <path d="M6 3 H18 V21 H6 Z" />
      <path d="M10 21 V17 H14 V21" />
      <path d="M9.5 7 H10.5 M13.5 7 H14.5 M9.5 11 H10.5 M13.5 11 H14.5" />
    </svg>
  )
);

const OneBrandChartV2: React.FC = () => {
  useInjectedStyles();
  const rootRef = React.useRef<HTMLDivElement>(null);
  const inView = useInView(rootRef);
  const [compact, setCompact] = React.useState(false);
  const [on, setOn] = React.useState(false);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const measure = (): void => setCompact(el.offsetWidth < 640);
    measure();
    window.addEventListener('resize', measure);
    let ro: ResizeObserver | undefined;
    if (typeof ResizeObserver !== 'undefined') { ro = new ResizeObserver(measure); ro.observe(el); }
    return () => { window.removeEventListener('resize', measure); if (ro) ro.disconnect(); };
  }, []);

  useEffect(() => {
    if (!inView) return;
    const t = window.setTimeout(() => setOn(true), 80);
    return () => window.clearTimeout(t);
  }, [inView]);

  // 29 companies: 8 operating, 1 management, 20 holding & service
  const kind = (i: number): string => (i < 8 ? 'op' : i === 8 ? 'mg' : 'hs');

  return (
    <div className={`obc2-root${compact ? ' compact' : ''}${on ? ' on' : ''}`} ref={rootRef}>
      <div className="head">
        <div>
          <h1>One group. <span className="gold">Twenty&#8209;nine subsidiaries.</span></h1>
          <p className="sub">Beacon College&rsquo;s listed parent and its subsidiaries, as set out in the June 2018 listing prospectus. Hong Kong school groups grow one registered school at a time &mdash; and the companies multiply faster than the campuses.</p>
        </div>
        <img className="obc2-logo" src={PSGLOBAL_LOGO} alt="PS Global Consulting" />
      </div>

      <div className="stage">
        <div className="v1">
            <div>
              <div className="big"><CountUp to={18} start={on} delay={150} /></div>
              <div className="side-lbl">teaching centres</div>
              <div className="cells">{Array.from({ length: 18 }, (_, i) => (
                <div className="cell ctr" key={i} style={{ transitionDelay: `${i * 20}ms` }}><SchoolIcon /></div>
              ))}</div>
              <p className="note">Each one registered &mdash; or provisionally registered &mdash; as a school under the Education Ordinance.</p>
            </div>
            <div>
              <div className="big gd"><CountUp to={29} start={on} delay={450} /></div>
              <div className="side-lbl">subsidiaries &mdash; under one listed company</div>
              <div className="cells">{Array.from({ length: 29 }, (_, i) => (
                <div className={`cell ${kind(i)}`} key={i} style={{ transitionDelay: `${300 + i * 20}ms` }}><BuildingIcon filled={i !== 8} /></div>
              ))}</div>
              <div className="key">
                <div className="ki"><i style={{ color: 'var(--teal)' }}><BuildingIcon /></i>district-coded operating companies</div>
                <div className="ki"><i style={{ color: 'var(--gold)' }}><BuildingIcon filled={false} /></i>management company</div>
                <div className="ki"><i style={{ color: '#a3e8e0' }}><BuildingIcon /></i>holding &amp; service companies</div>
              </div>
              <p className="note gd">The management company charges the operating companies a fee &mdash; an intercompany charge, eliminated at every close.</p>
            </div>
        </div>
      </div>

      <div className="foot">
        <p className="cap-l">Eighteen centres, one listed company &mdash; and beneath it, district-coded operating shells, a management company and the holding companies above them.</p>
      </div>
      <p className="src">Source: BExcellent Group Holdings (HKEX: 1775) prospectus, 30 Jun 2018. Education Ordinance (Cap. 279).</p>
    </div>
  );
};

export default OneBrandChartV2;
